import React, { Component, Fragment } from 'react';
import { Menu, Image, Container, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { authHeader } from '../helpers/auth-header.js';
import Configuration from '../config/Configuration.js';
import { createMedia } from "@artsy/fresnel";

import logo from '../images/logo-colour-small.png';
import icon from '../images/zipster-symbol-orange.png';

const AppMedia = createMedia({
    breakpoints: {
        mobile: 320,
        tablet: 768,
        computer: 992,
        largeScreen: 1200,
        widescreen: 1920
    }
});

const { Media, MediaContextProvider } = AppMedia;

class ZipsterMenu extends Component {

    constructor(props) {
        super(props);
        this.config = new Configuration();
        this.state = {
            organizationType: '',
        }
    }

    handleError(error) {
        console.log(error.message);
    }

    componentDidMount() {
        const userType = this.props.userType;
        console.log("Type: " + userType);
        if (userType === "practitioner") {
            const user = this.props.activeUser;
            if (user && user.organization) {
                this.retrieveOrganization(user.organization.uuid);
            }
        }
    }

    retrieveOrganization(uuid) {
        return fetch(this.config.ORGANIZATIONS_URL + "/" + uuid, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => response.ok ? response.json() : Promise.reject(response))
            .then(organization => {
                this.setState({ organizationType: organization.type });
            })
            .catch(error => this.handleError(error));
    }

    getActiveUserMenuItem = () => {
        if (this.props.activeUser) {
            let name = this.props.activeUser.name;
            if (this.props.activeUser.speciality && this.props.activeUser.speciality === "Huisarts") {
                name = "Dr. " + name;
            } else if (this.props.activeUser.speciality && this.props.activeUser.speciality === "Apotheker") {
                name = "Apotheker " + name;
            }
            return <Menu.Menu position='right'>
                <Menu.Item as={Link} to='/profile' name={name} />
            </Menu.Menu>;
        }
    }

    getSubMenus = () => {
        const { t } = this.props;
        const { activeUser, organizationType, userType } = this.state;

        if (userType === 'patient') {
            return (
                <Fragment>
                    <Menu.Item
                        name='aanbod'
                        as={Link} to='/services'>
                        <Icon name='handshake' />
                        {t("Services")}
                    </Menu.Item>
                </Fragment>
            );
        } else {

            if (!activeUser) {
                return null; // of een spinner / placeholder indien gewenst
            }

            if (activeUser.isObserver) {
                if (organizationType.includes(this.config.HYBRID_ORGANISATION)) {
                    return (
                        <Fragment>
                            <Menu.Item
                                name='doorverwijzingen'
                                as={Link} to='/referrals'>
                                <Icon name='mail forward' />
                                {t("Referrals")}
                            </Menu.Item>
                            <Menu.Item
                                name='aanvragen'
                                as={Link} to='/requests'>
                                <Icon name='street view' />
                                {t("Requests")}
                            </Menu.Item>
                        </Fragment>
                    );
                } else {
                    return (
                        <Menu.Item
                            name='aanvragen'
                            as={Link} to='/'>
                            <Icon name='street view' />
                            {t("Requests")}
                        </Menu.Item>
                    );
                }
            } else {
                return (
                    <Fragment>
                        <Menu.Item
                            name='doorverwijzingen'
                            as={Link} to='/'>
                            <Icon name='mail forward' />
                            {t("Referrals")}
                        </Menu.Item>
                        <Menu.Item
                            name='aanbod'
                            as={Link} to='/services'>
                            <Icon name='handshake' />
                            {t("Services")}
                        </Menu.Item>
                    </Fragment>
                );
            }
        }
    }

    getMenu = () => {
        const { t } = this.props;
        return <MediaContextProvider>
            <Container as={Media} greaterThanOrEqual="computer" fluid>
                <Menu fixed='top' borderless inverted color='blue' size='small'>
                    <Menu.Item as={Link} to='/' header>
                        <Image size='small' src={logo} spaced='left' />
                    </Menu.Item>
                    {this.getActiveUserMenuItem()}
                </Menu>
            </Container>
            <Container as={Media} lessThan="computer" fluid>
                <Menu fixed='top' borderless inverted color='blue' size='mini' icon='labeled'>
                    <Menu.Menu>
                        <Menu.Item as={Link} to='/' header>
                            <Image src={icon} size='mini' spaced='left' align='right' />
                        </Menu.Item>
                    </Menu.Menu>
                    <Menu.Menu position='right'>
                        {this.getSubMenus()}
                        <Menu.Item
                            name='beheer'
                            as={Link} to='/profile'>
                            <Icon name='edit' />
                            {t("My Profile")}
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            </Container>
        </MediaContextProvider>;
    }

    render() {
        return this.getMenu();
    }
}

export default withTranslation()(ZipsterMenu);;